import React, { Component } from 'react';
import {MLDefault} from '../../Components';



class TestViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {

        }
    }

    componentDidMount = async () => {
        console.log(`Envoirment ${process.env.REACT_APP_MODE}`)
     
    }


    shouldComponentUpdate(nextProps, nextState) {

        return true;
    }



    render = () => {
        return (
            <div>
                <h1><MLDefault name={"title"}/></h1>
                <button onClick={()=>this.props.setLanguage('en')} >English</button>
                <button onClick={()=>this.props.setLanguage('sin')} >Sinhala</button>
                <button onClick={()=>this.props.setLanguage('fr')} >French</button>
            </div>
        );
    };



}


/* Export Component ==================================================================== */
export default TestViewContainer;